<img class="corner-left">
<img class="corner-right">
<div #footer class="container nav-footer pt-4">
  <div class="row text-center">

    <div class="col-6 col-lg-3 d-flex flex-column align-items-center">
      <a class="flex-shrink-0" routerLink="/category">
        <h4 i18n="@@NavFooterMenuHomePageLink">Catalog</h4>
      </a>
    </div>

    <div class="col-6 col-lg-3 d-flex flex-column align-items-center justify-content-center">
      <a class="flex-shrink-0" [routerLink]="['/contact-request']">
        <h4 i18n="@@NavFooterMenuContactRequestLink">Contact request</h4>
      </a>
    </div>

    <div class="col-6 col-lg-3 d-flex flex-column align-items-center justify-content-center">
      <a class="flex-shrink-0" [routerLink]="['/content']" [queryParams]="{ parent: 'Terms' }">
        <h4 i18n="@@NavFooterMenuTermsLink">Terms</h4>
      </a>
    </div>

    <div class="col-6 col-lg-3 d-flex flex-column align-items-center justify-content-center">
      <a class="flex-shrink-0" [routerLink]="['/content']" [queryParams]="{ parent: 'LegalNotice' }">
        <h4 i18n="@@NavFooterMenuLegalLink">Legal notice</h4>
      </a>
    </div>

    <div class="col-6 col-lg-3 d-flex flex-column align-items-center justify-content-center">
      <a class="flex-shrink-0" [routerLink]="['/content']" [queryParams]="{ parent: 'TermsWebShop' }">
        <h4 i18n="@@NavFooterMenuTermsWebShopLink">Terms Webshop</h4>
      </a>
    </div>

    <div class="col-6 col-lg-3 d-flex flex-column align-items-center justify-content-center">
      <a class="flex-shrink-0" [routerLink]="['/content']" [queryParams]="{ parent: 'CookiePolicy' }">
        <h4 i18n="@@NavFooterMenuCookiePolicyLink">Cookie Policy</h4>
      </a>
    </div>

    <div class="col-6 col-lg-3 d-flex flex-column align-items-center justify-content-center">
      <a class="flex-shrink-0" [routerLink]="['/content']" [queryParams]="{ parent: 'PrivacyPolicy' }">
        <h4 i18n="@@NavFooterMenuPrivacyPolicyLink">Privacy Policy</h4>
      </a>
    </div>

    <div class="col-6 col-lg-3 d-flex flex-column align-items-center justify-content-center">
      <a class="flex-shrink-0" [routerLink]="['/content']" [queryParams]="{ parent: 'CGU' }">
        <h4 i18n="@@NavFooterMenuCGULink">Terms Universal</h4>
      </a>
    </div>

  </div>

  <div class="row align-items-center gy-3 pb-3 mt-1">

    <div class="col col-12 col-lg-6">
      <div class="d-flex justify-content-center justify-content-lg-start">
        <a class="text-muted mx-3" target="_blank">
          (R) 2022 Munhowen S.A. Tous droits réservés
        </a>
      </div>
    </div>

    <div class="col col-12 col-lg-6">
      <div class="d-flex justify-content-center justify-content-lg-end">
        <a class="text-muted mx-3" href="https://www.orga-soft.net" target="_blank">
          <img role="img" class="osbk-logo" alt="OSBK logo">
          <span class="ms-1">ORGA-SOFT INTEGRA GmbH © 2021-{{currentYear}}</span>
        </a>
      </div>
    </div>

  </div>

  <div class="row text-center gy-3 pb-3">
    <a class="text-muted" i18n="@@NavFooterMenuVATNote">All prices are without VAT and without deposit.</a>
  </div>

</div>
